import { ChatConversacion } from '../interfaces/chat.interface';

/** Chats mas recientes primero, sin mutar el array recibido. */
export function ordenarConversaciones(conversaciones: ChatConversacion[]): ChatConversacion[] {
  return [...conversaciones].sort(
    (a, b) => new Date(b.ultimaActualizacion).getTime() - new Date(a.ultimaActualizacion).getTime(),
  );
}
